import React, { useState } from "react";
import { useRoleVerify } from "Common/RoleVerify";
import { GetAll, Delete } from "adminApi/Terms&PrivacySocialApi/SosialLinks";
import DataTable from "Common/DataTable/DataTable";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import useTableConfig from "Hooks/useTableConfig";
import { generateDisplayFields } from "utils/fieldMapper";
import fields from "../../json/TermsAndPrivacyFields.json";
import { FilterStatus } from "utils/FilterStatus";

const SocialLinksTable = () => {
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const canShowAction = useRoleVerify("", ["can_edit", "can_delete"]);
  const sizeOptions = [10, 20, 50, 100];
  const { tabledataSocial } = fields;

  // Fetch data
  const { data, meta, loading, error, refetch } = usePaginatedFetch(
    GetAll,
    {
      page,
      limit,
      search,
      title: "Social Links",
    }
  );

  const displayFields = generateDisplayFields(tabledataSocial);
  const filteredData = FilterStatus(data);

  const { formattedData, columns } = useTableConfig({
    data: filteredData,
    page,
    limit,
    canShowAction,
    refetch,
    config: {
      entityName: "Social Link",
      editUrl: `edit-social-link`,
      idKey: "id",
      deleteApi: Delete,
      displayFields,
    },
  });

  const handleSearch = (val, resetPage = null) => {
    setSearch(val);
    if (resetPage !== null) setPage(resetPage);
  };

  const onPageChange = (p) => setPage(p);
  const onLimitChange = (newLimit) => {
    setLimit(newLimit);
    setPage(1);
  };

  return (
    <DataTable
      columns={columns}
      data={formattedData}
      options={{
        loading,
        error,
        sortableColumns: displayFields.map((f) => f.accessor),
      }}
      Search={{
        search: true,
        SearchInputValue: search,
        handleSearch,
      }}
      Entries={{
        Entries: true,
        limit,
        onLimitChange,
        options: sizeOptions,
      }}
      pagination={{
        isActive: true,
        meta,
        onPageChange,
      }}
    />
  );
};

export default SocialLinksTable;
